import { render, staticRenderFns } from "./CampaignsFilters.ts.vue?vue&type=template&id=6b145d2e&scoped=true"
import script from "./CampaignsFilters.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignsFilters.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CampaignsFilters.ts.vue?vue&type=style&index=0&id=6b145d2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b145d2e",
  null
  
)

export default component.exports